import Home from 'components/home/Home';

const Index = () => {
  return <Home />;
};

export default Index;
